<template>
	<div class="staff-carousel">
		<div class="row">
			<div class="col-md-11 offset-md-1 staff-carousel--thumbs">
				<swiper
					ref="swiperImages" :options="swiperOptionsImages" class="swiper"
				>
					<template v-for="(employee, index, i) in employees">
						<swiper-slide v-if="employee.is_exposed != '1'" class="staff-carousel__thumb" :class="`slide-${index}`" :key="index">
							<div class="slide-wrapper">
								<div class="image">
									<img loading="lazy" :src="employee.picture" :title="employee.title" :alt="employee.title">
								</div>
							</div>
						</swiper-slide>
					</template>
				</swiper>
			</div>
		</div>

		<div class="row">
			<div class="col-lg-6 col-md-9 offset-md-1 staff-carousel--text">
				<swiper
					ref="swiperText" :options="swiperOptionsText" class="swiper"
				>
					<template v-for="(employee, index) in employees">
					<swiper-slide v-if="employee.is_exposed != '1'" class="staff-carousel__text-block" :class="`slide-${index}`" :key="index">
						<div class="slide-wrapper">
							<div class="text">
								<div class="slide">{{ (index+1).toString().padStart(2, '0') }} / {{ totalSlides }}</div>
								<span class="text-caps-14" v-text="employee.position"></span>
								<h3 class="h5 h-alter" v-text="employee.title"></h3>
								<p v-text="employee.description"></p>
							</div>

							<span class="contact">
									<span class="contact-link email" v-if="employee.email"><a :href="`mailto:${employee.email}`" :title="employee.email"><svg class="ticon"><use xlink:href="/images/icons.svg?v1.3#icon-mail"></use></svg></a></span>
								<span class="contact-link linkedin" v-if="employee.linkedin"><a :href="employee.linkedin" title="LinkedIn" target="_blank" rel="nofollow noopener"><svg class="ticon"><use xlink:href="/images/icons.svg?v1.3#icon-linkedin"></use></svg></a></span>
								</span>
						</div>
					</swiper-slide>
					</template>
					<div class="swiper-button-next swiper-button-white" slot="button-next">
						{{ $__('page.pagination.next') }}
						<svg class="ticon ticon"><use xlink:href="/images/icons.svg#icon-chevron-right"></use></svg>
					</div>
					<div class="swiper-button-prev swiper-button-white" slot="button-prev">
						<svg class="ticon ticon-180"><use xlink:href="/images/icons.svg#icon-chevron-right"></use></svg>
						{{ $__('page.pagination.prev') }}
					</div>
				</swiper>
			</div>
		</div>
	</div>
</template>

<script>

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

export default {
	name: 'StaffCarousel',
	components: {
		Swiper,
		SwiperSlide
	},
	props: {
		employees: Array
	},
	data() {
		return {
			// employees: this.employee_list.filter(employee => employee.is_exposed != '1'),
			totalSlides: this.employees.length.toString().padStart(2, '0'),
			swiperOptionsImages: {
				loop: true,
				loopedSlides: 6, // looped slides should be the same
				// spaceBetween: 40,
				slideToClickedSlide: true,
				slidesPerColumnFill: 'column',
				touchRatio: 0.5,
				slidesPerView: 'auto',

			},
			swiperOptionsText: {
				loop: true,
				loopedSlides: 6, // looped slides should be the same
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				}
			}
		}
	},
	created: function() {
		// this.employees = this.employee_list.filter(employee => employee.is_exposed != '1');
		// this.totalSlides =  this.employees.length.toString().padStart(2, '0');
	},
	mounted() {
		this.$nextTick(() => {
			const swiperText = this.$refs.swiperText.$swiper;
			const swiperImages = this.$refs.swiperImages.$swiper;
			swiperText.controller.control = swiperImages;
			swiperImages.controller.control = swiperText;
		})
	}
}

</script>
